export const apiURL: string = import.meta.env.VITE_BFFAPI_URL;
export const wsURL: string = import.meta.env.VITE_WS_URL;
